import { useCallback } from "react";
import GeocodingService from "../services/GeocodingService";

const useGeocoding = () => {
  const getGeocoding = useCallback(async (
    latitude: number, 
    longitude: number, 
    maxRetries: number = 3
  ): Promise<string> => {
    const attemptGeocoding = async (attempt: number): Promise<string> => {
      try {
        const geocodingResult = await GeocodingService.reverseGeocode(latitude, longitude);
        const { fsa } = geocodingResult;
        return fsa;
      } catch (error: any) {
        console.warn(`Geocoding attempt ${attempt} failed:`, error.message);
        
        if (error.message === "Google Geocoding API key not configured" && attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          return attemptGeocoding(attempt + 1);
        }
        throw error;
      }
    };
    
    return attemptGeocoding(1);
  }, []);

  return { getGeocoding };
};

export default useGeocoding;